import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import Sidebar from "./components/Sidebar";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import ProtectedRoute from "./components/ProtectedRoute";

import Addproduct from "./pages/Addproduct";
import Categories from "./pages/Categories";
import Login from "./pages/Login";
import Orders from "./pages/Orders";
import Updateproduct from "./pages/Updateproduct";
import Users from "./pages/Users";
import Dashboard from "./pages/Dashboard";
import OrderDetail from "./pages/OrderDetail";
import BusinessDashboard from "./pages/BusinessDashboard";
import BusinessProducts from "./pages/BusinessProducts";
import BusinessWallet from "./pages/BusinessWallet";
import BusinessUsers from "./pages/BusinessUsers";
import BusinessOrders from "./pages/BusinessOrders";
import DieShapes from "./pages/DieShapes";
import BusinessOrderDetails from "./pages/BusinessOrderDetails";
import ViewProduct from "./pages/ViewProduct";
import AddBanner from "./pages/AddBanner";
import ClientLedger from "./pages/ClientLedger";
import BusinessCategory from "./pages/BusinessCategory";
import PendingTransactions from "./pages/PendingTransactions";

const Layout = () => {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";

  return (
    <div className="flex flex-col h-screen">
      {/* LOGIN ROUTE (PUBLIC) */}
      {isLoginPage ? (
        <Routes>
          <Route path="/login" element={<Login />} />
        </Routes>
      ) : (
        /* EVERYTHING ELSE IS PROTECTED */
        <ProtectedRoute>
          <>
            <Navbar />

            <div className="flex flex-1 overflow-hidden">
              <Sidebar className="w-64" />

              <main className="flex-1 overflow-auto">
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/addproduct" element={<Addproduct />} />
                  <Route path="/banner" element={<AddBanner />} />
                  <Route path="/product/:id" element={<ViewProduct />} />
                  <Route path="/categories" element={<Categories />} />
                  <Route path="/orders" element={<Orders />} />
                  <Route path="/updateproduct" element={<Updateproduct />} />
                  <Route path="/users" element={<Users />} />
                  <Route path="/order/:orderId" element={<OrderDetail />} />
                  <Route path="/ledger/:id" element={<ClientLedger />} />
                  <Route path="/dieShapes" element={<DieShapes />} />

                  {/* Business */}
                  <Route path="/businessDash" element={<BusinessDashboard />} />
                  <Route
                    path="/businessproducts"
                    element={<BusinessProducts />}
                  />
                  <Route path="/businessWallet" element={<BusinessWallet />} />
                  <Route path="/businessUsers" element={<BusinessUsers />} />
                  <Route path="/businessOrders" element={<BusinessOrders />} />
                  <Route
                    path="/businessCategory"
                    element={<BusinessCategory />}
                  />
                  <Route
                    path="/pending-transactions"
                    element={<PendingTransactions />}
                  />
                  <Route
                    path="/businessOrders-details/:id"
                    element={<BusinessOrderDetails />}
                  />

                  <Route path="*" element={<div>404 Not Found</div>} />
                </Routes>
              </main>
            </div>

            <Footer />
          </>
        </ProtectedRoute>
      )}
    </div>
  );
};

export default Layout;
